// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
const VALUE_INPUTS = "input, select, textarea, button, sp-select";

/** Returns whether `Sparkle.Utilities.setInputValue` sets `element` as a value input. */
export function isValueInput(element) {
  return element.matches(VALUE_INPUTS);
}

/**
 * Announces a scripted value change on an sp-select through a bubbling `change`. Returns whether `control` is an
 * sp-select; a native control is left silent.
 */
export function announceSelectChange(control) {
  if (control.localName !== "sp-select") {
    return false;
  }

  control.dispatchEvent(new Event("change", { bubbles: true }));

  return true;
}
